// 订单信息
export const orderList = [
    { key: 'customerName', label: '客户名称：', value: '' },
    { key: 'orderType', label: '订单类型：', value: '' },
    { key: 'sourceSystem', label: '订单来源：', value: '' },
    { key: 'centerName', label: '经营中心：', value: '' },
    { key: 'siteAndCompany', label: '服务平台：', value: '' },
    { key: 'taskType', label: '任务类型：', value: '' },
    { key: 'deliveryType', label: '配送方式：', value: '' },
    { key: 'deliveredVerifyFlag', label: '签收类型：', value: '' },
    { key: 'businessMode', label: '业务模式：', value: '' },
    { key: 'inOutTypeName', label: '出入库类型：', value: '' },
    { key: 'businessCategory', label: '业务大类：', value: '' },
    { key: 'remark', label: '备注：', value: '' }
    // {
    //     key: '',
    //     label: '订单信息：',
    //     value: '',
    //     valueFn: (row) => {
    //         return ['dpFlag', 'ifUpStairs', 'serviceType', 'scPosFlag'].map(key => row[key] || '无').join('-');
    //     },
    //     tooltip: '是否上门取件 - 是否上门 - 是否装送一体 - 是否商超'
    // },
    // {
    //     key: '',
    //     label: '任务类型：',
    //     value: '',
    //     valueFn: (row) => {
    //         return ['orderType', 'taskType', 'businessMode'].map(key => row[key] || '无').join('-');
    //     }
    // },
    // {
    //     key: '',
    //     label: '服务平台:',
    //     value: '',
    //     valueFn: (row) => {
    //         return ['companyName', 'siteName'].map(key => row[key] || '无').join('-');
    //     }
    // },
    // {
    //     key: '',
    //     label: '会计主体：',
    //     value: '',
    //     valueFn: (row) => {
    //         return ['invoiceUnitName', 'invoiceUnitCode'].map(key => row[key] || '无').join('-');
    //     }
    // },
    // { key: 'customerAgingType', label: '客户时效类型：', value: '' },
    // { key: 'whName', label: '发货仓库:', value: '' },
    // {
    //     key: '',
    //     label: '网点名称:',
    //     value: '',
    //     valueFn: (row) => {
    //         if (!row.networkName) {
    //             return '---';
    //         }
    //         return row.networkName + '（' + (row.endLat || '-') + ' / ' + (row.endLng || '-') + '）';
    //     }
    // },
    // {
    //     key: '',
    //     label: '分拨信息:',
    //     value: '',
    //     valueFn: (row) => {
    //         return ['distributionFlag', 'distributionWhName', 'distributionNum', 'distributionLastFlag'].map(key => row[key] || '无').join('-');
    //     },
    //     tooltip: '是否分拨-分拨仓-分拨段数-是否最后一段分拨'
    // },
    // { key: 'billingIncomeAdvanceFlag', label: '收入计费前置：', value: '' },
    // { key: 'billingCostAdvanceFlag', label: '成本计费前置：', value: '' },
    // { key: 'businessTypeName', label: '计费业务类型：', value: '' }
];

// 商品信息
export const tableProp = [
    {
        label: '商品行号',
        prop: 'lineNo',
        width: '100px'
    },
    {
        label: '客户商品编码',
        prop: 'customerItemCode',
        width: '200px'
    },
    {
        label: '商品编码',
        prop: 'itemCode',
        width: '180px'
    },
    {
        label: '商品名称',
        prop: 'itemName',
        width: '230px'
    },
    {
        label: '套机编码',
        prop: 'itemSuiteCode',
        width: '180px'
    },
    {
        label: '状态',
        prop: 'itemStatusName',
        width: '100px'
    },
    {
        label: '品牌',
        prop: 'cdcmBrand',
        width: '120px'
    },
    {
        label: '计划数量',
        prop: 'planQty',
        width: '100px'
    },
    {
        label: '实发数量',
        prop: 'actQty',
        width: '100px'
    },
    {
        label: '实扫数量',
        prop: 'rfActLoadQty',
        width: '100px'
    },
    {
        label: '实收数量',
        prop: 'realReceiveCount',
        width: '100px'
    },
    {
        label: '拆单源商品总数',
        prop: 'originTotalPlanQty',
        width: '200px',
        sort: true
    },
    {
        label: '拆单原因',
        prop: 'orderSplitReason',
        width: '200px',
        sort: true
    },
    {
        label: '包装规格',
        prop: 'cdcmPackageCode',
        width: '150px'
    },
    {
        label: '包装单位',
        prop: 'unit',
        width: '150px'
    },
    {
        label: '包件数',
        prop: 'pkgQty',
        width: '150px'
    },
    {
        label: '单台方量(m³)',
        prop: 'volume',
        width: '100px'
    },
    {
        label: '单台重量(kg)',
        prop: 'grossWeight',
        width: '100px'
    },
    {
        label: '财务单号',
        prop: 'financeNo',
        width: '110px'
    },
    {
        label: '商品分类',
        prop: 'itemClassName',
        width: '180px'
    },
    {
        label: '件型',
        prop: 'itemSize',
        width: '100px'
    },
    {
        label: '价格（元）',
        prop: 'price',
        width: '150px'
    },
    {
        label: '批次',
        prop: 'batchCode',
        width: '150px'
    },
    {
        label: '生产日期',
        prop: 'produceTimestamp',
        width: '150px'
    },
    {
        label: '失效日期',
        prop: 'expireTimestamp',
        width: '150px'
    },
    {
        label: '代贴标签数',
        prop: 'labelNumber',
        width: '110px'
    },
    {
        label: '代贴标签文件地址',
        prop: 'labelFile',
        width: '200px'
    },
    {
        label: '设备位号',
        prop: 'defineStr1',
        width: '200px'
    },
    {
        label: '库区',
        prop: 'itemZoneName',
        width: '160px'
    },
    {
        label: '库区编码',
        prop: 'itemZoneCode',
        width: '120px'
    }
];
